import { useState, useEffect } from "react";
import { message, Upload, Modal } from "antd";
import { fetchManagerProfile } from "PlatForms/OrgLMS/Services/ManagerService/ManagerProfileService";
import { updateManagerProfile } from "PlatForms/OrgLMS/Services/ManagerService/ManagerProfileService";
import { removeManagerProfilePicture } from "PlatForms/OrgLMS/Services/ManagerService/ManagerProfileService";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const useManagerProfile = (form) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [fileList, setFileList] = useState([]);
  const [removingImage, setRemovingImage] = useState(false);
  const token = localStorage.getItem("token");
  const { markProfileComplete, fetchProfileStatus} = useContext(ProfileContext);

  const getProfile = async () => {
    try {
      setLoading(true);
      const response = await fetchManagerProfile(token);
      const data = response.data;
      setProfileData(data);

      form.setFieldsValue({
        firstName: data.firstName,
        lastName: data.lastName,
        phoneNo: data.phoneNo,
        country: data.country,
        state: data.state,
        city: data.city,
        managerCode: data.managerCode,
        managerId: data.managerId,
        // businessGroupId: data.businessGroup?.name,
        businessGroupId: data.businessGroup?.id || data.businessGroup?.name,
      });

      if (data.profileImage) {
        setImageUrl(`${process.env.REACT_APP_URL}${data.profileImage}`);
      }
    } catch (error) {
      message.error("Failed to fetch profile data");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


const updateProfile = async (values, navigate) => {
  try {
    setUpdating(true);
    const response = await updateManagerProfile(token, values, fileList);

    setProfileData(response.data);
    message.success("Profile updated successfully", 2.5);
      markProfileComplete();
      setTimeout(() => {
  fetchProfileStatus();
}, 1000);
        


    if (response.data.profileImage) {
      setImageUrl(`${process.env.REACT_APP_URL}${response.data.profileImage}`);
    }

    setFileList([]);
    return true; // Always return success
  } catch (error) {
    console.error("Update profile error:", error);
    message.error("Failed to update profile");
    return false;
  } finally {
    setUpdating(false);
  }
};



  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    const isLt1M = file.size / 1024 / 1024 < 1;

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }

    if (!isLt1M) {
      Modal.warning({ title: "Picture is too large", content: "This picture is over 1MB. Please choose an image under 1MB, then upload again." });
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleImageChange = (info) => {
    let newFileList = [...info.fileList].slice(-1);

    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);

    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const reader = new FileReader();
      reader.onload = (e) => setImageUrl(e.target.result);
      reader.readAsDataURL(newFileList[0].originFileObj);
    }
  };

  const removeProfilePicture = async () => {
    try {
      setRemovingImage(true);
      await removeManagerProfilePicture(token);
      setImageUrl("");
      setFileList([]);
      setProfileData((prev) => (prev ? { ...prev, profileImage: null } : prev));
      message.success("Profile picture removed");
    } catch (error) {
      console.error("Error removing profile picture:", error);
      message.error("Failed to remove profile picture");
    } finally {
      setRemovingImage(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return {
    profileData,
    loading,
    updating,
    imageUrl,
    fileList,
    beforeUpload,
    handleImageChange,
    updateProfile,
    setFileList,
    removeProfilePicture,
    removingImage,
  };
};

export default useManagerProfile;
